import { PanelViewBase } from '@softline/ui-core';
import { Resource, Signal } from '@angular/core';

export abstract class RemoteDataPanelViewBase<T> extends PanelViewBase {
  abstract resource: Signal<Resource<T>>;
}
